"use strict";

var debug = require("debug")("knack.formatter.formatters.file");

/**
 * @alias "formatters.file"
 * @param {Object} value
 * @param {String} [value.original_id] Either value._id or value.id must be set instead
 * @param {String} [value._id] Either value.original_id or value.id must be set instead
 * @param {String} [value.id] Either value._id or value.original_id must be set instead
 * @param {String} value.field_key
 * @param {String} value.filename
 * @param {Object} [format]
 * @param {Object} req
 * @param {String} [req.application._id]
 * @param {String} [req.headers.'x-knack-application-id']
 * @return {String}
 */
var fileFormatter = function fileFormatter(value, format, req) {
  var assetId = String(value.original_id || value._id || value.id);
  var protocol = process.env.NODE_ENV === "development" ? "http://" : "https://";
  var applicationId = "";
  if (!value || !value.field_key || !value.filename) {
    return "";
  }
  if (value.url) {
    return "<a class=\"kn-view-asset\" data-field-key=\"".concat(value.field_key, "\" data-asset-id=\"").concat(assetId, "\" data-file-name=\"").concat(value.filename, "\" href=\"").concat(value.url, "\">").concat(value.filename, "</a>");
  }
  if (req && req.application && req.application._id) {
    applicationId = req.application._id;
  } else if (req && req.headers && req.headers["x-knack-application-id"]) {
    applicationId = req.headers["x-knack-application-id"];
  }
  var returnValue = "<a class=\"kn-view-asset\" data-field-key=\"".concat(value.field_key, "\" data-asset-id=\"").concat(assetId, "\" data-file-name=\"").concat(value.filename, "\"");
  returnValue += " href=\"".concat(protocol, "api.").concat(value.domain, "/v1/applications/").concat(applicationId, "/download/asset/").concat(assetId, "/").concat(value.filename);
  returnValue += "\">".concat(value.filename, "</a>");
  return returnValue;
};
module.exports = fileFormatter;